// extracted by mini-css-extract-plugin
export var RecruitThemeContent__theme = "RecruitThemeContent-module--RecruitThemeContent__theme--3MrtY";
export var small = "RecruitThemeContent-module--small--3VW3W";